/**
 * Get the map padding that should be used when update map center.
 * Accounts for overlays that should be treated as padding and whether is mobile or not.
 */
const getMapPadding = (isMobile: boolean) => {
  return {
    // 372 is how much the left overlay cover
    left: isMobile ? 0 : 372,
    // 48 is how much the control buttons cover
    right: isMobile ? 0 : 48,
  };
};

/**
 * Calculate the map bounds that should be used when update map center.
 * Accounts for overlays that should be treated as padding and whether is mobile or not.
 * @param position - The position to center on.
 * @param zoom - The current zoom level of the map.
 * @param isMobile - Whether we are on a mobile screen dimensions
 * @returns The map bounds that should be used when update map center.
 */
const calculateMapBounds = (
  position: { latitude: number; longitude: number },
  zoom: number,
  isMobile = false,
) => {
  const latOffset = 360 / Math.pow(2, zoom + 1);
  const lngOffset = 360 / Math.pow(2, zoom + 1);

  return {
    region: {
      north: position.latitude + latOffset,
      south: position.latitude - latOffset,
      east: position.longitude + lngOffset,
      west: position.longitude - lngOffset,
    },
    padding: getMapPadding(isMobile),
  };
};

export { calculateMapBounds, getMapPadding };
